export function resolveClientsConfigId(nodes, orderNodeId) {
  if (orderNodeId === undefined || orderNodeId === null || orderNodeId === '') return null
  const id = Number(orderNodeId)
  if (!Number.isFinite(id)) return null
  const list = Array.isArray(nodes) ? nodes : []
  const orderNode = list.find((n) => Number(n.id) === id)
  if (!orderNode || orderNode.object_type_code !== 'ot_orders') return null
  const sibling = list.find((n) =>
    String(n.parent_id) === String(orderNode.parent_id) &&
    n.object_type_code === 'ot_clients' &&
    !n.hide
  )
  return sibling ? sibling.id : null
}
